/** Humanize keys like best_time_to_connect_you_ → Best Time To Connect You */
export function formatFieldLabel(key: string): string {
  return String(key || "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

const SKIP_KEYS = new Set([
  "full_name",
  "fullname",
  "email",
  "phone",
  "phone_number",
  "phonenumber",
  "leadname",
  "leademail",
  "leadphone",
]);

/**
 * Normalize lead.dynamicFields / dynamicFeilds into label/value rows for display.
 * Supports JSON strings, answer maps, and form field definition arrays.
 */
export function parseLeadExtraFields(
  lead: any
): Array<{ label: string; value: string }> {
  if (!lead) return [];

  const raw = lead.dynamicFields ?? lead.dynamicFeilds;
  if (raw == null || raw === "") return [];

  let parsed: any = raw;
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return [];
    }
  }

  const rows: Array<{ label: string; value: string }> = [];

  const pushMap = (obj: Record<string, any>) => {
    Object.entries(obj || {}).forEach(([key, val]) => {
      if (val == null || val === "") return;
      if (SKIP_KEYS.has(String(key).toLowerCase())) return;
      if (typeof val === "object") return;
      rows.push({
        label: formatFieldLabel(key),
        value: String(val),
      });
    });
  };

  if (Array.isArray(parsed)) {
    if (
      parsed.length === 1 &&
      parsed[0] &&
      typeof parsed[0] === "object" &&
      !("name" in parsed[0]) &&
      !("label" in parsed[0]) &&
      !("answer" in parsed[0]) &&
      !("fieldName" in parsed[0])
    ) {
      pushMap(parsed[0]);
      return rows;
    }

    parsed.forEach((field: any) => {
      if (!field || typeof field !== "object") return;
      const value = field.answer ?? field.value ?? field.fieldValue;
      if (value == null || value === "") return;
      if (typeof value === "object") return;
      const label =
        field.label ||
        field.displayName ||
        formatFieldLabel(field.name || field.fieldName || "Field");
      rows.push({ label: String(label), value: String(value) });
    });
    return rows;
  }

  if (typeof parsed === "object") {
    pushMap(parsed);
  }

  return rows;
}
